<panel scrollable>
  <h1>New Order</h1>
  <section>
    <custom-select #companysearch [selectList]="companyResults" [(value)]="newOrderCompanyId" (valueChange)="changeCompany($event)" (keyup)="searchCompanies()" [label]="'general.companyname' | translate" />
  </section>
  @if (newOrder) {
    <h3>Products</h3>
    <section>
      <div>
        <custom-select [selectList]="productVariantItems" [(value)]="newOrderLineVariantId" label="Variant" (valueChange)="updatePrice()" />
      </div>
      <div>
        <custom-select [selectList]="companyProductPlans" [(value)]="newOrderLineBillingPlanBasedOnProductPlanId" label="Billingplan based on" />
      </div>
    </section>
    <section>
      <div>
        <custom-input [inputType]="inputTypeEnum.Currency" [(value)]="newOrderLinePrice" label="Price" />
      </div>
      <div>
        <custom-select [selectList]="paymentIntervalItems" [(value)]="newOrderLineInterval" label="Interval" [required]="true" />
      </div>
      <div>
        <custom-input [inputType]="inputTypeEnum.Number" [(value)]="newOrderLineInstallments" label="Number of installments" />
      </div>
    </section>
    <section>
      <div>
        <custom-input [inputType]="inputTypeEnum.Currency" [(value)]="newOrderLineStartupAmount" label="Startup" />
      </div>
      <div>
        <custom-select [selectList]="startupRateItems" [(value)]="newOrderLineStartupInstallments" label="Startup installments" />
      </div>
    </section>
    <section>
      <button (click)="addProduct();" [loader]="false" [ignoreValidation]="true" [active]="newOrderLineVariantId != undefined"><icon type="plus" />{{ 'general.add' | translate }}</button>
    </section>
    <h3>Discontinue</h3>
    <section>
      <div>
        <custom-select [selectList]="companyProductPlans" [(value)]="discontinueProductPlanId" label="Discontinue productplan" />
      </div>
      <div>
        <custom-input [inputType]="inputTypeEnum.Currency" [(value)]="discontinueAdjustmentAmount" label="Adjustment amount" />
      </div>
      <div>
        <custom-input [inputType]="inputTypeEnum.Currency" [(value)]="discontinueRemainingAmount" label="Remaining amount" />
      </div>
    </section>
    <section>
      <button (click)="addDiscontinuedProduct();" [loader]="false" [ignoreValidation]="true" [active]="discontinueProductPlanId != undefined"><icon type="plus" />{{ 'general.add' | translate }}</button>
    </section>
    @if (newOrder.products.length > 0) {
      <section>
        <card>
          <section header>
            <h3>Added products</h3>
          </section>
          <list-view scrollable>
            <header>Product</header>
            <header>Price</header>
            <header>Interval</header>
            <header>Startup</header>
            <row *listData="let product from newOrder.products">
              <column [sortValue]="getProductName(product.productVariantId!)">{{ getProductName(product.productVariantId!) }}</column>
              <column [sortValue]="product.unitPrice">{{ product.unitPrice | currency }}</column>
              <column [sortValue]="product.paymentInterval">{{ product.paymentInterval }}</column>
              <column [sortValue]="product.startupAmount">{{ product.startupAmount | currency }}</column>
              <menu [visibleMenuButton]="false">
                <menuitem (click)="removeProduct(product)"><icon type="trash-alt" /></menuitem>
              </menu>
            </row>
          </list-view>
        </card>
      </section>
    }
    @if (newOrder.productPlanDiscontinuations.length > 0) {
      <section>
        <card>
          <section header>
            <h3>Added discontinuations</h3>
          </section>
          <list-view scrollable>
            <header>ProductName</header>
            <header>Counter</header>
            <header>Remaining</header>
            <row *listData="let product from newOrder.productPlanDiscontinuations">
              <column [sortValue]="getDiscontinuedProductName(product.productPlanId!)">{{ getDiscontinuedProductName(product.productPlanId!) }}</column>
              <column [sortValue]="product.counterAmount">{{ product.counterAmount | currency }}</column>
              <column [sortValue]="product.remainingAmount">{{ product.remainingAmount | currency }}</column>
              <menu [visibleMenuButton]="false">
                <menuitem (click)="removeDiscontinuedProduct(product)"><icon type="trash-alt" /></menuitem>
              </menu>
            </row>
          </list-view>
        </card>
      </section>
    }
    <section>
      <button #submitorder confirm (click)="createOrder()">{{ 'general.create' | translate }}</button>
    </section>
  }
</panel>
